import { Card, List, ListItem, ListItemSecondaryAction } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import axios from 'axios';
import Hashids from 'hashids';
import React, { useEffect, useState } from 'react';
import { ChevronRight as ChevronRightIcon } from 'react-feather';
import { useNavigate } from 'react-router-dom';

import Breadcrumb from '@/components/common/breadcrumb.component';
import { Constants } from '@/constants';

const hashids = new Hashids('', 12);

const RolesView = () => {
  const navigate = useNavigate();
  const [loadingRoles, setLoadingRoles] = useState(true);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    axios
      .get(`${Constants.apiPath}/roles`)
      .then((res) => {
        setRoles(res.data);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoadingRoles(false));
  }, []);

  return (
    <div>
      <Breadcrumb title="Roles" label="Roles" parent="Settings" />

      <div className="container-fluid">
        <div
          style={{
            maxWidth: 800,
            width: '100%',
            margin: '30px auto',
          }}
        >
          {!loadingRoles && (
            <Card
              style={{
                maxWidth: 1200,
                width: '100%',
                margin: '30px auto',
              }}
            >
              <List>
                {roles
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((role) => (
                    <ListItem
                      key={role.role_id}
                      onClick={() =>
                        navigate(
                          `/settings/roles/${hashids.encode(role.role_id)}`
                        )
                      }
                      style={{ cursor: 'pointer' }}
                    >
                      <ListItemText
                        primary={role.name}
                        secondary={role.description}
                      />
                      <ListItemSecondaryAction>
                        <ChevronRightIcon
                          style={{
                            height: 18,
                            width: 18,
                            marginLeft: 10,
                            cursor: 'pointer',
                          }}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
              </List>
            </Card>
          )}
        </div>
      </div>
    </div>
  );
};

export default RolesView;
